import { isSSR } from '@helpers/ssr';
import { useI18N } from '@vivino/js-web-common';
import PropTypes from 'prop-types';
import React from 'react';
import ReactDOMServer from 'react-dom/server';
import EditorsPickIcon from 'vivino-js/icons/EditorsPick';
import DiscountPercentLabel from 'vivino-ui/atoms/DiscountPercentLabel';

import styles from './bestPickBanner.scss';

const TRANSLATIONS = {
  bestPick: 'components.deal_wine_page.editors_pick_banner.best_pick',
};

export const BestPickBanner = ({ price }) => {
  const { t } = useI18N();
  if (!price) {
    return null;
  }

  const discountPercentLabel = <DiscountPercentLabel price={price} />;

  return (
    <div className={styles.headline}>
      <span className={styles.icon} style={{ display: 'block', width: '32px', height: '32px' }}>
        <EditorsPickIcon />
      </span>
      <span className={styles.headlineText}>
        {t(TRANSLATIONS.bestPick)}
        {!isSSR && ReactDOMServer.renderToString(discountPercentLabel) && (
          <span className={styles.headlineSave}>
            &nbsp;-&nbsp;
            {discountPercentLabel}
          </span>
        )}
      </span>
    </div>
  );
};

BestPickBanner.propTypes = {
  price: PropTypes.object,
};

export default BestPickBanner;
